import {
    LOGIN_INITIALISE_SUCCESS,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    SET_MESSAGE,
    CANCEL_PERMISSIONS,
} from "./types";

import AuthentificationService from "../services/authentification.service";
import oidcAuthentication from "../services/oidcAuthentication.service";

export const login = (username, password, authnAttemptId, rsaInitialiseMessageId, rsaAuthnAttemptId) => (dispatch) => {
    return AuthentificationService.login(username, password, authnAttemptId, rsaInitialiseMessageId, rsaAuthnAttemptId).then(
        (data) => {
            if (data.isAuthentificated === false) {
                dispatch(logout());
                dispatch({
                    type: SET_MESSAGE,
                    payload: data.message,
                });
            }
            else {
                dispatch({
                    type: LOGIN_SUCCESS,
                    payload: { user: data.user},
                });
            }

            return Promise.resolve();
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: LOGIN_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    );
};

export const loginInitialise = (username, password) => (dispatch) => {
    return AuthentificationService.loginInitialise(username, password).then(
        (data) => {
            dispatch({
                type: LOGIN_INITIALISE_SUCCESS,
                payload: data,
            });
            return Promise.resolve();
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: LOGIN_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    );
};

export const logout = () => (dispatch) => {
    var isEmpty = !localStorage.getItem("oidc");
    dispatch(clearSession())
    if (!isEmpty) {
        oidcAuthentication.getSignout().then(d => {
            if (d && d.redirect && d.uri) {
                window.location.replace(d.uri);
            } else {
                dispatch(clearSession());
            }
        })
    }
};

export const clearSession = () => (dispatch) => {
    AuthentificationService.logout();
    dispatch({ type: LOGOUT });
    dispatch({ type: CANCEL_PERMISSIONS });
};